module.exports = __webpack_public_path__ + "img/imagotipoHorizontalNegro.c01030bd.png";